export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  RESERVED = 'reserved',
  GHOST = 'ghost',
  GHOST_WARNING = 'ghost-warning',
  WARNING = 'warning',
  CONTRAST = 'contrast',
  ICON = 'icon',
  ICON_GHOST = 'icon-ghost',
  ERROR = 'error',
}

export enum ButtonSizes {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}
